import { createSlice } from "@reduxjs/toolkit";
import {
  createRespondentAdministratorAction,
  updateRespondentAdministratorAction,
  deleteRespondentAdministratorAction,
  getRespondentAdministratorByCaseIDAction,
  deleteRespondentAdministratorDocumentAction,
} from "../../actions/RespondentAdministrator/respondentAdministratorAction";

// ============================================================================
// INITIAL STATE
// ============================================================================

const initialState = {
  administrators: [],
  loading: false,
  error: null,
  success: false,
  successMessage: "",
};

// ============================================================================
// SLICE
// ============================================================================

const respondentAdministratorSlice = createSlice({
  name: "respondentAdministrator",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
      state.successMessage = "";
    },
  },
  extraReducers: (builder) => {
    // =========================================================================
    // GET COUNSELS BY CASE ID
    // =========================================================================
    builder
      .addCase(getRespondentAdministratorByCaseIDAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getRespondentAdministratorByCaseIDAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.administrators = action.payload.data || [];
        },
      )
      .addCase(
        getRespondentAdministratorByCaseIDAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );

    // =========================================================================
    // CREATE COUNSEL
    // =========================================================================
    builder
      .addCase(createRespondentAdministratorAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createRespondentAdministratorAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.success = true;
          state.successMessage = "Administrator created successfully";
          state.administrators.push(action.payload.data);
        },
      )
      .addCase(
        createRespondentAdministratorAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );

    // =========================================================================
    // UPDATE COUNSEL
    // =========================================================================
    builder
      .addCase(updateRespondentAdministratorAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        updateRespondentAdministratorAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.success = true;
          state.successMessage = "Administrator updated successfully";

          const index = state.administrators.findIndex(
            (c) =>
              c.respondentAdministrator_ID ===
              action.payload.data.respondentAdministrator_ID,
          );

          if (index !== -1) {
            state.administrators[index] = action.payload.data;
          }
        },
      )
      .addCase(
        updateRespondentAdministratorAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );

    // =========================================================================
    // DELETE COUNSEL
    // =========================================================================
    builder
      .addCase(deleteRespondentAdministratorAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        deleteRespondentAdministratorAction.fulfilled,
        (state, action) => {
          state.loading = false;
          state.success = true;
          state.successMessage = "Administrator deleted successfully";

          state.administrators = state.administrators.filter(
            (c) => c.respondentAdministrator_ID !== action.payload,
          );
        },
      )
      .addCase(
        deleteRespondentAdministratorAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );

    // =========================================================================
    // DELETE COUNSEL DOCUMENT
    // =========================================================================
    builder
      .addCase(deleteRespondentAdministratorDocumentAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        deleteRespondentAdministratorDocumentAction.fulfilled,
        (state) => {
          state.loading = false;
          state.success = true;
          state.successMessage = "Document deleted successfully";
        },
      )
      .addCase(
        deleteRespondentAdministratorDocumentAction.rejected,
        (state, action) => {
          state.loading = false;
          state.error = action.payload;
        },
      );
  },
});

export const { clearError, clearSuccess } =
  respondentAdministratorSlice.actions;
export default respondentAdministratorSlice.reducer;
